export default __webpack_public_path__ + "static/media/notification.aa32f8f9.svg";